/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespTradeOnApprovalCoachmarkLoader_item$ref = any;
export type PdpRespTradeOnApprovalCoachmarkLoader_item = {
    readonly serviceId: string | null;
    readonly " $refType": PdpRespTradeOnApprovalCoachmarkLoader_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespTradeOnApprovalCoachmarkLoader_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '0d7fad06a94145eca46080caf0dc776d';
export default node;
